import { useRef } from 'react';
import { useRouter } from 'next/router';
import { getUrlFriendly } from 'components/corporatiu/Enllac/RouteResolver';
import Enllac from 'components/corporatiu/Enllac/Enllac';
import Icona from 'components/corporatiu/Icona/';
import styles from './capcaleracercador.module.scss';

const CapcaleraCercador = (props) => {
    const { titol, routePathTitol, routePathCerca, mostraCercador = true, tag = 'div' } = props;
    const router = useRouter();
    const inputRef = useRef(null);

    const Tag = tag === 'h1' ? 'h1' : 'div';

    const handleSubmit = (e) => {
        e.preventDefault();
        const value = inputRef.current.value;
        if (value && value.length > 0) {
            router.push(
                getUrlFriendly({
                    routePath: routePathCerca,
                    slug: value
                })
            );
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSubmit(e);
        }
    };

    const routeTitol = {
        type: routePathTitol
    };

    return (
        <div className={styles.stylesContent}>
            <div className={styles.capcaleraWrapper}>
                <Enllac route={routeTitol}>
                    <Tag className={styles.titolCapcalera}>{titol}</Tag>
                </Enllac>
                {mostraCercador && (
                    <form onSubmit={handleSubmit} className={styles.searchForm}>
                        <div className={styles.innerSearcher}>
                            <label htmlFor='search' className='sr-only'>
                                Buscar:
                            </label>
                            <input
                                ref={inputRef}
                                type='search'
                                placeholder='Cerca documents'
                                className={styles.inputCerca}
                                onKeyDown={handleKeyDown}
                            />
                            <button type='submit' className={styles.searchButton} aria-label='buscar'>
                                <Icona className={styles.icona} icona='cercador' isBlanc={false} />
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
};

export default CapcaleraCercador;
